import { VisuallyHidden } from '@treatwell/ui';
import { FAQsSection } from 'js/components/FAQsSection';
import { Context } from 'js/components/LocaleWrapper';
import { FooterBannerSection } from 'js/components/Loyalty/FooterBanner/FooterBannerSection';
import { HeroSectionContainer } from 'js/components/Loyalty/Hero';
import { InstructionStepsSectionContainer } from 'js/components/Loyalty/InstructionSteps';
import { RedeemTreatsSectionContainer } from 'js/components/Loyalty/RedeemTreats';
import { TreatsConversionSectionContainer } from 'js/components/Loyalty/TreatsConversion';
import { generateFAQsContent } from 'js/components/Loyalty/utils/generateFAQsContent';
import { useTrackPageAndSessionView } from 'js/hooks/useTrackPageAndSessionView';
import { CMSTreatwellRewardsPage } from 'js/model/cms/cms-treatwell-rewards';
import { ChannelLoyalty } from 'js/model/rainbow/content/ChannelOutput';
import React from 'react';

export const TreatwellRewardsPage = () => {
  const { channel, pageData } = React.useContext(Context);
  useTrackPageAndSessionView();
  const channelLoyalty = channel as ChannelLoyalty;
  const cms: CMSTreatwellRewardsPage = pageData.cms;
  const cmsFAQs = cms.page['treatwell-rewards'].faqs;

  return (
    <>
      <VisuallyHidden as="h1">Treatwell Rewards</VisuallyHidden>
      <HeroSectionContainer channel={channelLoyalty} cmsValues={cms} />
      <TreatsConversionSectionContainer
        channel={channelLoyalty}
        cmsValues={cms}
      />
      <InstructionStepsSectionContainer
        channel={channelLoyalty}
        cmsValues={cms}
      />
      <RedeemTreatsSectionContainer channel={channelLoyalty} cmsValues={cms} />
      <FAQsSection
        header={{ title: cmsFAQs.title, description: cmsFAQs.description }}
        faqs={generateFAQsContent({
          channel: channelLoyalty,
          cmsFAQs: cmsFAQs['faqs-content'].faq,
        })}
        showAllFAQsButtonLabel={cmsFAQs['see-all-faqs']}
      />
      <FooterBannerSection cmsValues={cms} />
    </>
  );
};
